<template>
  <div class="">
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <div class="w100">
      <form @submit.prevent>
        <div class="row">
          <div class="col">
            <div class="row mb-3">
              <div class="col">
                <label for="Subject" class="form-label">件名</label>
                <input
                  type="text"
                  class="form-control"
                  id="Subject"
                  placeholder="件名"
                  v-model="information.subject"
                />
              </div>
            </div>
            <div class="row mb-3">
              <div class="col d-none">
                <label for="Status" class="form-label">公開</label>
                <bs-select
                  :options="information_public_type_list"
                  v-model="information.public_type"
                  :null-option="false"
                  id="Status"
                  :class-param="'form-select-sm'"
                ></bs-select>
              </div>
              <div class="col" v-if="false">
                <label for="LangType" class="form-label">言語</label>
                <bs-select
                  :options="app_lang_type_list"
                  v-model="information.lang_type"
                  :null-option="true"
                  id="LangType"
                  :class-param="'form-select-sm'"
                ></bs-select>
              </div>
              <div class="col d-none">
                <label for="setDateTime" class="form-label">時間</label>
                <input
                  type="time"
                  class="form-control"
                  id="setDateTime"
                  placeholder="時間"
                  v-model="information.set_date_time_val"
                />
              </div>
            </div>
            <div class="row mb-3">
              <div class="col">
                <label for="setDate" class="form-label">日付</label>
                <div class="input-group">
                  <div class="input-group-text">
                    <input
                      class="form-check-input mt-0"
                      type="checkbox"
                      v-model="information.date_null_flg"
                      aria-label="受付終了を設定するならチェック"
                    />
                  </div>
                  <input
                    type="date"
                    class="form-control"
                    id="setDate"
                    placeholder="日付"
                    :disabled="information.date_null_flg ? true : false"
                    v-model="information.set_date_date_val"
                  />
                </div>
                <!-- <input type="date" class="form-control" id="setDate" placeholder="日付" v-model="information.set_date_date_val"> -->
              </div>
              <div class="col">
                <label for="CategoryType" class="form-label"
                  >お知らせ種別</label
                >
                <bs-select
                  :options="information_category_type_list"
                  v-model="information.category_type"
                  :null-option="false"
                  id="CategoryType"
                  :class-param="'form-select'"
                ></bs-select>
              </div>
              <div class="col">
                <label for="TargetType" class="form-label">配信先</label>
                <bs-select
                  :options="information_target_type_list"
                  v-model="information.target_type"
                  :null-option="false"
                  id="TargetType"
                  :class-param="'form-select'"
                ></bs-select>
              </div>
            </div>
            <div class="row mb-5">
              <div class="col" v-if="information.header_image_path">
                <p
                  class="alert alert-warning"
                  v-if="information.header_del_flg == true"
                >
                  ヘッダ画像を削除します
                </p>
                <img
                  :src="information.header_image_path"
                  class="w-100"
                  v-else
                />
              </div>
              <div class="col" v-else>
                <p class="alert alert-warning">ヘッダ画像をアップできます。</p>
              </div>
              <div class="col">
                <p>
                  <label for="Body" class="form-label">ヘッダ画像</label>
                  <input
                    type="file"
                    class="form-control"
                    id=""
                    name=""
                    @change="selectedHeaderFile($event)"
                    accept="image/*"
                  />
                </p>
                <p class="my-2">
                  <input
                    type="checkbox"
                    id="header_del_flg"
                    v-model="information.header_del_flg"
                  />&nbsp;
                  <label for="header_del_flg"> ヘッダー画像を削除する </label>
                </p>
              </div>
            </div>
            <div class="row mb-5">
              <div class="col-12" :class="{ 'col-lg-6': showSidePreview }">
                <label for="Body" class="form-label">本文</label>

                <!-- マークダウンのツールバー -->
                <div class="markdown-toolbar mb-2 border rounded p-2 bg-light">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div class="toolbar-buttons">
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary me-1"
                        @click="insertMarkdown('header1')"
                      >
                        <i class="bi bi-type-h1"></i> 大見出し
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary me-1"
                        @click="insertMarkdown('header2')"
                      >
                        <i class="bi bi-type-h2"></i> 中見出し
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary me-1"
                        @click="insertMarkdown('bold')"
                      >
                        <i class="bi bi-type-bold"></i> 太字
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary me-1"
                        @click="insertMarkdown('list')"
                      >
                        <i class="bi bi-list-ul"></i> リスト
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary me-1"
                        @click="insertMarkdown('numberedList')"
                      >
                        <i class="bi bi-list-ol"></i> 番号付きリスト
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary me-1"
                        @click="insertMarkdown('link')"
                      >
                        <i class="bi bi-link-45deg"></i> リンク
                      </button>
                    </div>
                    <div class="preview-buttons">
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-primary me-2"
                        @click="toggleSidePreview"
                      >
                        <i
                          class="bi"
                          :class="
                            showSidePreview
                              ? 'bi-layout-sidebar-reverse'
                              : 'bi-layout-sidebar'
                          "
                        ></i>
                        {{
                          showSidePreview
                            ? 'プレビューを隠す'
                            : 'プレビューを表示'
                        }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm btn-primary"
                        @click="toggleModalPreview"
                      >
                        <i class="bi bi-arrows-fullscreen"></i>
                        全画面プレビュー
                      </button>
                    </div>
                  </div>
                </div>

                <!-- マークダウンのヘルプ -->
                <div class="markdown-help mb-2 border rounded bg-light">
                  <div
                    class="help-header p-2 border-bottom d-flex justify-content-between align-items-center"
                    @click="toggleHelp"
                    style="cursor: pointer"
                  >
                    <small class="mb-0 d-flex align-items-center">
                      <i class="bi bi-info-circle me-1"></i>
                      書式のヘルプ
                      <span class="ms-2 badge bg-info">クリックで開閉</span>
                    </small>
                    <i
                      class="bi"
                      :class="showHelp ? 'bi-chevron-up' : 'bi-chevron-down'"
                    ></i>
                  </div>
                  <div class="help-content p-3" v-show="showHelp">
                    <div class="row g-3">
                      <div class="col-md-6">
                        <div class="help-section">
                          <h6 class="help-title">
                            <i class="bi bi-type-h1"></i> 見出し
                          </h6>
                          <div class="help-item">
                            <code># 大見出し</code>
                            <i class="bi bi-arrow-right mx-2"></i>
                            <span class="result h5 mb-0">大見出し</span>
                          </div>
                          <div class="help-item">
                            <code>## 中見出し</code>
                            <i class="bi bi-arrow-right mx-2"></i>
                            <span class="result h6 mb-0">中見出し</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="help-section">
                          <h6 class="help-title">
                            <i class="bi bi-type-bold"></i> 文字装飾
                          </h6>
                          <div class="help-item">
                            <code>**太字**</code>
                            <i class="bi bi-arrow-right mx-2"></i>
                            <span class="result fw-bold">太字</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="help-section">
                          <h6 class="help-title">
                            <i class="bi bi-list"></i> リスト
                          </h6>
                          <div class="help-item">
                            <code>- リスト項目</code>
                            <i class="bi bi-arrow-right mx-2"></i>
                            <div class="result">
                              <ul class="mb-0">
                                <li>リスト項目</li>
                              </ul>
                            </div>
                          </div>
                          <div class="help-item">
                            <code>1. 番号付きリスト</code>
                            <i class="bi bi-arrow-right mx-2"></i>
                            <div class="result">
                              <ol class="mb-0">
                                <li>番号付きリスト</li>
                              </ol>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="help-section">
                          <h6 class="help-title">
                            <i class="bi bi-link-45deg"></i> リンク
                          </h6>
                          <div class="help-item">
                            <code>[リンク](URL)</code>
                            <i class="bi bi-arrow-right mx-2"></i>
                            <span class="result">
                              <a href="#" class="text-decoration-none"
                                >リンク</a
                              >
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-3 pt-2 border-top">
                      <small class="text-muted">
                        <i class="bi bi-lightbulb"></i>
                        ヒント：テキストを選択してからボタンをクリックすると、選択部分に書式が適用されます
                      </small>
                    </div>
                  </div>
                </div>

                <textarea
                  class="form-control"
                  id="Body"
                  v-model="information.body"
                  rows="10"
                  ref="bodyTextarea"
                ></textarea>
              </div>

              <!-- サイドプレビュー部分 -->
              <div v-if="showSidePreview" class="col-12 col-lg-6">
                <div class="preview-wrapper">
                  <h5>プレビュー</h5>
                  <div class="preview-container">
                    <!-- 日付表示 -->
                    <div class="preview-date">
                      {{ information.set_date_date_val }}
                      {{ information.set_date_time_val }}
                    </div>

                    <!-- タイトル -->
                    <div class="preview-title">
                      {{ information.subject }}
                    </div>

                    <!-- ヘッダー画像 -->
                    <div
                      class="preview-header-image"
                      v-if="information.header_image_path"
                    >
                      <span
                        v-if="information.header_del_flg"
                        class="preview-image-delete-notice"
                      >
                        (画像は削除されます)
                      </span>
                      <img
                        v-else
                        :src="information.header_image_path"
                        class="w-100"
                        alt="ヘッダー画像"
                      />
                    </div>

                    <!-- 本文 -->
                    <div
                      class="preview-body markdown-content"
                      v-html="parsedBody"
                    ></div>

                    <!-- 添付ファイル -->
                    <div
                      class="preview-attachments"
                      v-if="information.assets && information.assets.length"
                    >
                      <div v-for="asset in information.assets" :key="asset.id">
                        <a :href="asset.path" class="preview-attachment-link">
                          <i class="bi bi-file-earmark"></i>
                          {{ asset.label }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-5">
              <div class="col">
                <h4>ファイル一覧</h4>
                <div
                  class="row border-bottom py-2"
                  v-for="(asset, index) in information.assets"
                  :key="asset"
                >
                  <div class="mb-1 col-10">
                    <input
                      type="t9xt"
                      class="form-control"
                      v-model="asset.label"
                    />
                  </div>
                  <div class="mb-1 col-2">
                    <a @click="delAsset(index)" class="btn btn-warning btn-sm">
                      <i class="bi bi-trash"></i>
                    </a>
                  </div>
                  <div class="col-12">
                    <a :href="asset.path" class="btn btn-sm btn-info">
                      <i class="bi bi-file"></i>&nbsp;ファイル
                    </a>
                  </div>
                </div>
              </div>
              <div class="col">
                <label for="Body" class="form-label">ファイル</label>
                <input
                  type="file"
                  class="form-control"
                  id="file_up_input"
                  name=""
                  @change="selectedFile($event)"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12 col-sm-4 mb-2">
            <router-link
              to="/information/list"
              class="btn btn-light btn-outline-secondary"
              >戻る</router-link
            >
          </div>
          <div
            class="col-12 col-sm-4 mb-2 text-center"
            v-if="chk_relation_type_editable('/information/data')"
          >
            <bs-button
              :btnClass="'btn-primary'"
              @to_click_event="handleClick"
              >{{ btnLabel }}</bs-button
            >
          </div>
        </div>
      </form>
    </div>

    <!-- モーダルプレビュー -->
    <div
      v-if="showModalPreview"
      class="preview-modal"
      @click.self="toggleModalPreview"
    >
      <div class="preview-modal-content">
        <div class="preview-modal-header">
          <h5>プレビュー</h5>
          <button
            type="button"
            class="btn-close"
            @click="toggleModalPreview"
            aria-label="Close"
          ></button>
        </div>
        <div class="preview-modal-body">
          <div class="preview-container">
            <!-- 日付表示 -->
            <div class="preview-date">
              {{ information.set_date_date_val }}
              {{ information.set_date_time_val }}
            </div>

            <!-- タイトル -->
            <div class="preview-title">
              {{ information.subject }}
            </div>

            <!-- ヘッダー画像 -->
            <div
              class="preview-header-image"
              v-if="information.header_image_path"
            >
              <span
                v-if="information.header_del_flg"
                class="preview-image-delete-notice"
              >
                (画像は削除されます)
              </span>
              <img
                v-else
                :src="information.header_image_path"
                class="w-100"
                alt="ヘッダー画像"
              />
            </div>

            <!-- 本文 -->
            <div
              class="preview-body markdown-content"
              v-html="parsedBody"
            ></div>

            <!-- 添付ファイル -->
            <div
              class="preview-attachments"
              v-if="information.assets && information.assets.length"
            >
              <div v-for="asset in information.assets" :key="asset.id">
                <a :href="asset.path" class="preview-attachment-link">
                  <i class="bi bi-file-earmark"></i>
                  {{ asset.label }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsButton from '../../atoms/BsButton.vue'
import BsSelect from '../../atoms/BsSelect.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import config from '../../../const'
import axios from 'axios'
import { marked } from 'marked'
import DOMPurify from 'dompurify'

export default {
  name: 'InformationDetailView',
  data: function () {
    return {
      add: true,
      alertMessage: '',
      alertClass: 'alert-info',
      targetid: this.$route.params.id ? this.$route.params.id : 'add',
      fromParentTitle: 'お知らせデータ',
      fromParentBtn: '',
      information: {},
      information_category_type_list: [],
      information_target_type_list: [],
      information_public_type_list: [],
      showSidePreview: false,
      showModalPreview: false,
      showHelp: true
    }
  },
  components: {
    BsPageTitle,
    BsMsgAlert,
    BsButton,
    BsSelect
  },
  methods: {
    delAsset(index) {
      const tmp = this.information.assets
      tmp.splice(index, 1)
      this.information.assets = tmp
    },
    selectedHeaderFile(e) {
      e.preventDefault()
      const files = [...e.target.files]
      files.forEach(file => {
        const form = new FormData()
        form.append('file', file)
        axios
          .post(config.BASE_API_URL + '/upload/information', form, {
            headers: this.axiosHeader
          })
          .then(res => {
            console.log(res)
            if (res && res.status == 200) {
              this.information.header_image_path = res.data.body.file_path
              // ups.push(res.data.body);
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    selectedFile: function (e) {
      e.preventDefault()
      const files = [...e.target.files]
      // let ups = [];
      files.forEach(file => {
        const form = new FormData()
        form.append('file', file)
        axios
          .post(config.BASE_API_URL + '/upload/information', form, {
            headers: this.axiosHeader
          })
          .then(res => {
            console.log(res)
            if (res && res.status == 200) {
              const asset = {
                id: 0,
                stat: 1,
                label: res.data.body.up_file_name
                  ? res.data.body.up_file_name
                  : '',
                path: res.data.body.file_path ? res.data.body.file_path : ''
              }
              // console.log('asset', asset);
              // console.log('this.information', this.information);
              if (!Array.isArray(this.information.assets)) {
                this.information.assets = []
              }
              const assets = [...this.information.assets]
              // console.log('assets', assets);
              assets.push(asset)
              this.information.assets = assets

              // ups.push(res.data.body);
            }
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            document.getElementById('file_up_input').value = ''
          })
      })
    },
    handleClick() {
      // バリデーションチェックを追加
      if (
        !this.information.category_type ||
        !this.information.public_type ||
        !this.information.target_type
      ) {
        this.alertMessage = 'お知らせ種別、公開種別、配信先は必須項目です'
        this.alertClass = 'alert-danger'
        alert(this.alertMessage)
        return
      }

      // データの型変換を確実に行う
      const sendData = {
        ...this.information,
        category_type: parseInt(this.information.category_type),
        target_type: parseInt(this.information.target_type),
        target_data: [],
        public_type: parseInt(this.information.public_type),
        mypage_flg: parseInt(this.information.mypage_flg || 0),
        mail_flg: parseInt(this.information.mail_flg || 0),
        sort: parseInt(this.information.sort || 0)
      }
      if (
        typeof this.information.target_data === 'object' &&
        this.information.target_data.length <= 0
      ) {
        sendData.target_data.push({
          id: 0,
          stat: 1,
          information_id: 0,
          target_type: parseInt(this.information.target_type)
        })
      } else if (typeof this.information.target_data === 'object') {
        const info_tmp = { ...this.information }
        const target_data_tmps = [...info_tmp.target_data]
        target_data_tmps[0].target_type = parseInt(this.information.target_type)
        sendData.target_data = target_data_tmps
      }

      // 日付の処理
      if (this.information.date_null_flg) {
        sendData.set_date_date_val = null
      }

      // デバッグ用ログ出力
      console.log('Sending data to API:', sendData)

      return this.$store
        .dispatch('updateBasic', {
          data: sendData,
          target: 'information'
        })
        .then(() => {
          this.alertMessage = this.btnLabel + 'しました'
          this.alertClass = 'alert-success'
          alert(this.alertMessage)
        })
        .catch(error => {
          console.error('API Error:', error)
          this.alertMessage = this.btnLabel + 'できませんでした'
          this.alertClass = 'alert-danger'
          alert(this.alertMessage)
          return Promise.reject(error)
        })
    },

    loadAppLangType() {
      return this.$store
        .dispatch('fetchBasicLists', { data: {}, target: 'app_lang_type' })
        .catch(err => Promise.reject(err))
        .then(() => {
          // console.log('loard complete sex');
          // console.log('this', this.$store.state.apidata.sex);
          // this.$router.push({ path: '/login' })
        })
        .finally(() => {
          console.log(' pref', this.$store.state.apidata.app_lang_type)
        })
    },
    async loadInformation(targetid) {
      const params = { id: targetid } // IDをパラメータとして設定
      const params_ = this.createParams(params)
      try {
        const response = await axios.post(
          config.BASE_API_URL + '/information/lists',
          params_,
          {
            headers: this.axiosHeader
          }
        )
        const ret = response.data.body ? response.data.body[0] : null
        if (ret) {
          ret['header_del_flg'] = false
          ret['date_null_flg'] =
            ret['set_date_date_val'] == null ||
            ret['set_date_date_val'] == '0000-00-00 00:00:00'
          ret['target_type'] =
            Array.isArray(ret.target_data) && ret.target_data.length > 0
              ? ret.target_data[0]['target_type']
              : 1
          this.information = ret
          console.log('this.information', this.information)
        } else {
          console.error('データが見つかりませんでした')
        }
      } catch (err) {
        console.error('情報の取得に失敗:', err)
        this.information = {} // エラー時は空のオブジェクトを設定
      }
    },
    createParams(params) {
      const params_ = new URLSearchParams()
      if (params) {
        const keys = Object.keys(params)
        for (let i = 0; i < keys.length; i++) {
          if (keys[i] == 'p') {
            params_.append(keys[i], params[keys[i]])
          } else {
            params_.append('sprm[' + keys[i] + ']', params[keys[i]])
          }
        }
      }
      return params_
    },
    async loadCategoryTypes() {
      try {
        const response = await axios.get(
          `${config.BASE_API_URL}/config/information_category_type`,
          { headers: this.axiosHeader }
        )
        this.information_category_type_list = response.data.body || []
      } catch (error) {
        console.error('カテゴリー種別の取得に失敗:', error)
        this.information_category_type_list = []
      }
    },

    async loadTargetTypes() {
      try {
        const response = await axios.get(
          `${config.BASE_API_URL}/config/information_target_type`,
          { headers: this.axiosHeader }
        )
        this.information_target_type_list = response.data.body || []
      } catch (error) {
        console.error('配信先種別の取得に失敗:', error)
        this.information_target_type_list = []
      }
    },
    async loadPublicTypes() {
      try {
        const response = await axios.get(
          `${config.BASE_API_URL}/config/information_public_type`,
          { headers: this.axiosHeader }
        )
        this.information_public_type_list = response.data.body || []
      } catch (error) {
        console.error('公開種別の取得に失敗:', error)
        this.information_public_type_list = []
      }
    },
    insertMarkdown(type) {
      const textarea = this.$refs.bodyTextarea
      const start = textarea.selectionStart
      const end = textarea.selectionEnd
      const text = this.information.body
      const selectedText = text.substring(start, end)

      let insertion = ''
      switch (type) {
        case 'header1':
          insertion = `# ${selectedText || '大見出し'}`
          break
        case 'header2':
          insertion = `## ${selectedText || '中見出し'}`
          break
        case 'bold':
          insertion = `**${selectedText || '太字にしたい文字'}**`
          break
        case 'list':
          insertion = selectedText
            ? selectedText
                .split('\n')
                .map(line => `- ${line}`)
                .join('\n')
            : '- リスト項目\n- リスト項目\n- リスト項目'
          break
        case 'numberedList':
          insertion = selectedText
            ? selectedText
                .split('\n')
                .map((line, index) => `${index + 1}. ${line}`)
                .join('\n')
            : '1. リスト項目\n2. リスト項目\n3. リスト項目'
          break
        case 'link':
          insertion = selectedText
            ? `[${selectedText}](URLを入力)`
            : '[リンクテキスト](URLを入力)'
          break
      }

      this.information.body =
        text.substring(0, start) + insertion + text.substring(end)

      // カーソル位置の調整
      this.$nextTick(() => {
        textarea.focus()
        const newCursorPos = start + insertion.length
        textarea.setSelectionRange(newCursorPos, newCursorPos)
      })
    },
    toggleSidePreview() {
      this.showSidePreview = !this.showSidePreview
    },
    toggleModalPreview() {
      this.showModalPreview = !this.showModalPreview
    },
    toggleHelp() {
      this.showHelp = !this.showHelp
    }
  },
  computed: {
    ...mapState({
      app_lang_type_list: state => state.apidata.app_lang_type,
      btnLabel() {
        if (this.add) {
          return '新規登録'
        } else {
          return '更新'
        }
      }
    }),
    parsedBody() {
      if (!this.information.body) return ''
      const rawHtml = marked(this.information.body)
      return DOMPurify.sanitize(rawHtml)
    },
    axiosHeader: function () {
      return { [config.BASE_API_HEADER_KEY]: this.$store.state.auth.token }
    }
  },
  async created() {
    await Promise.all([
      this.loadAppLangType(),
      this.loadCategoryTypes(),
      this.loadTargetTypes(),
      this.loadPublicTypes()
    ])

    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    }
    console.log('targetid', this.targetid)
    if (this.targetid == 'add') {
      this.information = {
        subject: '',
        body: '',
        header_del_flg: false,
        date_null_flg: true,
        assets: [],
        category_type: 1, // デフォルト値を設定
        public_type: 1, // デフォルト値を設定
        target_type: 1, // デフォルト値を設定
        stat: 0
      }
      console.log('this.type', this.type)
    } else {
      this.add = false
      await this.loadInformation(this.targetid)
    }

    // マークダウンの設定
    marked.setOptions({
      breaks: true, // 改行を有効化
      gfm: true // GitHub Flavored Markdownを有効化
    })
  },
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article);
    // console.log('this', ...this.$store.getters.getArticleById(1));
    this.fromParentTitle = 'お知らせ詳細'
    this.alertMessage = this.btnLabel + 'できます'
    // console.log('tags_list', this.tags_list);
  },

  // computed: {
  //   article () {
  //     // const id = parseInt(this.$route.params.id);
  //     // console.log(id, 'idid');
  //     console.log('ret', ret);
  //     return ret;
  //   }
  // },
  props: {
    // article: {
    //   type: Object,
    //   required: true,
    //   default: () => {}
    // },
    onupdate: {
      type: Function,
      required: true
    }
  }
}
</script>

<style scoped>
.markdown-toolbar {
  background-color: #f8f9fa;
  border-bottom: none !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.markdown-toolbar button {
  font-size: 0.875rem;
  padding: 0.25rem 0.5rem;
}

.markdown-toolbar button i {
  font-size: 1rem;
  margin-right: 0.25rem;
}

.markdown-help {
  background-color: #f8f9fa;
  border-top: none !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  font-size: 0.875rem;
}

.markdown-help code {
  background-color: #e9ecef;
  padding: 2px 4px;
  border-radius: 3px;
  color: #e83e8c;
  font-size: 0.8125rem;
}

.markdown-help .row {
  margin: 0 -0.5rem;
}

.markdown-help .col-md-4 {
  padding: 0 0.5rem;
}

textarea.form-control {
  border-radius: 4px;
  min-height: 200px;
  font-family: monospace;
  line-height: 1.5;
  padding: 0.75rem;
}

/* プレビュー全体のスタイル */
.preview-container {
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: 1rem;
}

/* 日付のスタイル */
.preview-date {
  color: #6c757d;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

/* タイトルのスタイル */
.preview-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: #333;
}

/* ヘッダー画像のスタイル */
.preview-header-image {
  margin-bottom: 2rem;
  border-radius: 4px;
  overflow: hidden;
}

.preview-image-delete-notice {
  display: inline-block;
  padding: 0.5rem;
  background: #fff3cd;
  color: #856404;
  border-radius: 4px;
}

/* 本文のスタイル */
.preview-body {
  color: #333;
  line-height: 1.8;
  margin-bottom: 2rem;
}

/* マークダウンコンテンツのスタイル */
.markdown-content :deep(h1) {
  font-size: 1.8rem;
  font-weight: 600;
  margin: 2rem 0 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e9ecef;
}

.markdown-content :deep(h2) {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 1.5rem 0 1rem;
  padding-bottom: 0.3rem;
  border-bottom: 1px solid #e9ecef;
}

.markdown-content :deep(p) {
  margin-bottom: 1rem;
}

.markdown-content :deep(ul),
.markdown-content :deep(ol) {
  margin-bottom: 1rem;
  padding-left: 1.5rem;
}

.markdown-content :deep(li) {
  margin-bottom: 0.5rem;
}

.markdown-content :deep(a) {
  color: #007bff;
  text-decoration: none;
}

.markdown-content :deep(a:hover) {
  text-decoration: underline;
}

.markdown-content :deep(strong) {
  font-weight: 600;
  color: #2c3e50;
}

/* 添付ファイルのスタイル */
.preview-attachments {
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #e9ecef;
}

.preview-attachment-link {
  display: inline-flex;
  align-items: center;
  color: #007bff;
  text-decoration: none;
  margin-bottom: 0.5rem;
  padding: 0.5rem;
  background: #f8f9fa;
  border-radius: 4px;
}

.preview-attachment-link i {
  margin-right: 0.5rem;
}

.preview-attachment-link:hover {
  background: #e9ecef;
  text-decoration: none;
}

.preview-wrapper {
  position: sticky;
  top: 1rem;
  max-height: calc(100vh - 2rem);
  overflow-y: auto;
}

/* プレビューが表示されているときのレスポンシブ調整 */
@media (max-width: 991px) {
  .preview-wrapper {
    position: static;
    max-height: none;
    margin-top: 1rem;
  }

  .preview-container {
    margin-bottom: 2rem;
  }
}

/* ツールバーのプレビューボタン */
.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
}

.btn-primary:hover {
  background-color: #0056b3;
  border-color: #0056b3;
}

.btn-primary i {
  margin-right: 0.5rem;
}

/* ツールバーのレスポンシブ対応 */
@media (max-width: 768px) {
  .toolbar-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .markdown-toolbar .d-flex {
    flex-direction: column;
  }

  .btn-primary {
    width: 100%;
    margin-top: 0.5rem;
  }
}

/* プレビュー時のスクロールバーのスタイリング */
.preview-wrapper::-webkit-scrollbar {
  width: 8px;
}

.preview-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.preview-wrapper::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.preview-wrapper::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* モーダル関連のスタイル */
.preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 1050;
  padding: 2rem;
  overflow-y: auto;
}

.preview-modal-content {
  background: #fff;
  border-radius: 8px;
  width: 100%;
  max-width: 1500px;
  height: 90%;
  margin: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.preview-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
}

.preview-modal-header h5 {
  margin: 0;
  font-size: 1.25rem;
}

.preview-modal-body {
  padding: 1rem;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

.preview-container {
  max-width: 100%;
  margin: 0 auto;
  background: #ffffff;
  padding: 2rem;
}

/* レスポンシブ対応 */
@media (max-width: 768px) {
  .preview-modal {
    padding: 1rem;
  }

  .preview-container {
    padding: 1rem;
  }
}

/* スクロールバーのスタイリング */
.preview-modal-body::-webkit-scrollbar {
  width: 8px;
}

.preview-modal-body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.preview-modal-body::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.preview-modal-body::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.preview-buttons {
  display: flex;
  align-items: center;
}

@media (max-width: 768px) {
  .preview-buttons {
    margin-top: 0.5rem;
    width: 100%;
  }

  .preview-buttons button {
    flex: 1;
  }
}

/* ツールバーのボタンアイコン */
.btn i {
  margin-right: 0.25rem;
}

/* プレビューボタンのスタイル */
.btn-outline-primary {
  border-color: #007bff;
  color: #007bff;
}

.btn-outline-primary:hover {
  background-color: #007bff;
  color: #fff;
}

.help-header {
  transition: background-color 0.2s;
}

.help-header:hover {
  background-color: #e9ecef;
}

.help-content {
  transition: all 0.3s ease;
}

.bi-chevron-up,
.bi-chevron-down {
  transition: transform 0.3s ease;
}

.help-section {
  background: white;
  padding: 1rem;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.help-title {
  color: #0d6efd;
  margin-bottom: 0.75rem;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 0.5rem;
}

.help-item {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.help-item:last-child {
  margin-bottom: 0;
}

.help-item code {
  background: #f8f9fa;
  padding: 0.25rem 0.5rem;
  border-radius: 3px;
  color: #e83e8c;
  font-size: 0.875rem;
}

.help-item .result {
  background: #f8f9fa;
  padding: 0.25rem 0.5rem;
  border-radius: 3px;
  font-size: 0.875rem;
}

.help-item .bi-arrow-right {
  color: #6c757d;
}

.badge.bg-info {
  font-weight: normal;
  font-size: 0.75rem;
}
</style>
